import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { Heading } from 'lib/components/styles/typography';
import { MdAdd } from 'react-icons/md';
import { CustomerStatistics } from 'lib/context';
import { CardType, StatsCard } from './StatsCard';
import { IoIosLogIn } from 'react-icons/io';
import { Button } from 'react-covideo-common';
import { RESELLER_IDS } from 'lib/const';
import { ToggleContainer, ToggleLabel } from '../../resellers/main/Details';
import Switch from 'app/pages/design/landingPageBuilder/components/Switch';
import { Flex } from 'lib/components/styles/layout';

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 32px;
`;

const LeftHeaderWrapper = styled.div`
  display: flex;
  gap: 48px;
`;

const StatsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

type Props = {
  statistics: CustomerStatistics;
  loading: boolean;
  showNewCustomerButton: boolean;
  resellerId?: number;
  isSetupComplete?: boolean;
  handleSetUpToggle?: () => void;
  onAddNewCustomer(): void;
  importCustomers(): void;
};

export const CustomersHeader = ({
  statistics,
  loading,
  showNewCustomerButton,
  resellerId,
  isSetupComplete,
  handleSetUpToggle,
  onAddNewCustomer,
  importCustomers,
}: Props) => {
  const activeCustomersCount =
    !loading && statistics?.active ? statistics.active : 0;
  const inactiveCustomersCount =
    !loading && statistics?.inActive ? statistics.inActive : 0;
  const isCDK = resellerId?.toString() === RESELLER_IDS.CDK;
  const themes = useTheme();
  return (
    <Flex gap='32px'>
      {!!isCDK && (
        <ToggleContainer>
          <ToggleLabel>CDK Setup Complete</ToggleLabel>
          <Switch
            id={'switch-only-my-c'}
            isOn={!!isSetupComplete}
            onColor={themes.colors.primary[100]}
            handleToggle={() => {
              handleSetUpToggle && handleSetUpToggle();
            }}
          />
        </ToggleContainer>
      )}
      <HeaderWrapper>
        <LeftHeaderWrapper>
          <Heading color={themes.colors.neutral[100]}>Customers</Heading>
          <StatsWrapper>
            <StatsCard count={activeCustomersCount} text={'active customers'} />
            <StatsCard
              count={inactiveCustomersCount}
              text={'inactive customers'}
              cardType={CardType.SECONDARY}
            />
          </StatsWrapper>
        </LeftHeaderWrapper>
        <ButtonContainer>
          <Button
            variant='secondary'
            icon={<IoIosLogIn />}
            onClick={importCustomers}
            text='Import'
          />
          {showNewCustomerButton && (
            <Button
              icon={<MdAdd color={themes.colors.white[100] || '#fff'} />}
              onClick={onAddNewCustomer}
              text='New Customer'
            />
          )}
        </ButtonContainer>
      </HeaderWrapper>
    </Flex>
  );
};
